import React, { useState } from 'react';
import { Modal, Input } from 'antd';

interface Props {
  record: any;
  isVisible: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteConfirmation: React.FC<Props> = ({ record, isVisible,onConfirm, onClose }) => {
  const [inputValue, setInputValue] = useState('');
  const confirmationString = 'I want to delete';


  return (
    <Modal
      title={isVisible ? `Are you sure you want to delete ${record.document_name}?` : ''}
      open={isVisible}
      onCancel={ () => {
        onClose();
        setInputValue('')}
      }
      okButtonProps={{
        disabled: inputValue !== confirmationString,
      }}
      onOk={() => {
        // Implement your delete logic here, e.g.:
        // ... rest of your logic
        onConfirm();
        onClose(); // close the modal
        setInputValue('')
      }}
    >
      {isVisible && (
        <div>
          <p>Please type "{confirmationString}" to confirm:</p>
          <Input value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
        </div>
      )}
    </Modal>
  );
};

export default DeleteConfirmation;
